import { defineFcm } from '../shared/factory';

export const FCM_LCM_STARTER_PETITION_COMMENT_DIGEST_ENABLED = defineFcm('lcm_starter_petition_comment_digest_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Enables sending starter petition comment digest messages to Iterable.',
		import: false,
	});
